import config from '@/config/index';

/**
     * 增加案例
     *
     * @param caseName             案例名称
     * @param caseContent          案例内容
     * @param logo                 图片
     * @param contacts             联系人
     * @param mobile               手机号
     * @param amountlower          金额上限
     * @param amountupper          金额下限
     * @param nonamount            金额面议
     * @param show                 是否显示
     * @param background           项目背景
     * @param solving              解决问题
     * @param constructionThinking 建设思路
     * @param constructionEffect   建设成效
     * @param request
     * @return
     */
function addCase() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/case`;
}

function modifyCase() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/modifycase`;
}

/**
     * @param id     服务id
     * @param request
     * @return
     */
function deleteCase() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/deletecase`;
}

/**
   * @param id     服务ID
   * @return
   */
function getCaseById(id) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/case/${id}`;
}

/**
   * @param orgid 机构ID
   * @return
   */
function getCasesByOrgid(orgid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/casesbyorgid/${orgid}`;
}



export {
    addCase,
    modifyCase,
    deleteCase,
    getCaseById,
    getCasesByOrgid
};
